import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {MSpinner, MCard} from "components/Shared";
import {getMCardConfiguration, getMCardData, updateMCardData} from "requests/customerConfiguration";
import {getVariableGridCellSize} from "components/Shared/Functions";
import {insertValueFieldIntoCards} from "selectors/homeowner/caseForms/caseHeaderV2";
import responseHandler from "responseHandler";
import AppraisalRequirements from "components/Customer/SurveyTypes/SurveyTypeRequirements.tsx";

// From Mueller.Business.BusinessLogic.CustomerSurveyBusinessLogic
export const INFO_CARD_KEY = "complete-form-surveyTypeCard";
export const BILLING_CARD_KEY = "complete-form-billingCard";
export const REQUIREMENTS_CARD_KEY = "complete-form-requirementsCard"; 

const CustomerSurveyTypeConfiguration = (props) => {
  const [data, setData] = useState(null);
  const [mCardConfiguration, setMCardConfiguration] = useState(null);
  const [mCardConfigurationApplied, setMCardConfigurationApplied] = useState(null);
  const [isBusy, setIsBusy] = useState(true);
  const mounted = useRef(true);

  useEffect(() => {
    return () => mounted.current = false;
  }, []);

  useEffect(() => {
    setIsBusy(true);
    setData(null);
    setMCardConfiguration(null);
    getMCardData(props.customerNumber, props.surveyTypeCode, setData, mounted);
    getMCardConfiguration(props.customerNumber, props.surveyTypeCode, setMCardConfiguration, mounted);
  }, [props.customerNumber, props.surveyTypeCode]);

  useEffect(() => {
    if (data && mCardConfiguration) {
      setIsBusy(true);
      let cardsAndData = {
        cards: global.structuredClone(mCardConfiguration),
        caseHeaderDto: data,
      };
      insertValueFieldIntoCards(cardsAndData);
      setMCardConfigurationApplied(cardsAndData.cards);
      setIsBusy(false);
    }
  }, [data, mCardConfiguration]);

  const handleSave = (updatedData) => {
    let dictData = {};
    // transform to an IDictionary structure for the web call
    updatedData.forEach((d) => {
      if (typeof (d.value) === "undefined") {
        dictData[d.key] = null;
      } else {
        dictData[d.key] = d.value;
      }
    });
    setIsBusy(true);
    // throw error when only updating FieldServiceAutoQaStartDate when !EnableFieldServicesAutoQa 
    let throwErrorFSQA = (dictData.hasOwnProperty("FieldServiceAutoQaStartDate") && !dictData.hasOwnProperty("EnableFieldServicesAutoQa") && !data.enableFieldServicesAutoQa);
    if (throwErrorFSQA) {
      props.makeToastError("Field Services Auto QA must be set to Yes to set Field Services Auto QA Start Date.");
      setIsBusy(false);
      return;
    }
    updateMCardData(props.customerNumber, props.surveyTypeCode, dictData, setData, null, mounted);
  };

  const totalCards = mCardConfigurationApplied?.length - 1; // Subtract 1 here because we're hardcoding 1 card below to always be full width
  if (!mCardConfiguration || !data || !mCardConfigurationApplied || isBusy) {
    return <MSpinner/>;
  }
  return (
    <>
      {mCardConfigurationApplied.map((c, i) =>
        <MCard
          {...c}
          key={c.key}
          cellWidth={(props.verticalDisplay || c.key === REQUIREMENTS_CARD_KEY) ? 12 : getVariableGridCellSize(totalCards, i)}
          onEditFinished={handleSave}
          children={c.key === REQUIREMENTS_CARD_KEY 
            ? <AppraisalRequirements />
            : null}
        />)}
    </>);

};

CustomerSurveyTypeConfiguration.propTypes = {
  customerNumber: PropTypes.number,
  surveyTypeCode: PropTypes.string,
  verticalDisplay: PropTypes.bool,
  makeToastError: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  makeToastError: text => {
    responseHandler.customToast(text, "error", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(CustomerSurveyTypeConfiguration);
